"use strict";

var BackboneChangeMixin = {
  componentDidMount: function() {
    if (this.props.collection) {
        this.props.collection.on("add remove change sort", this.forceUpdate.bind(this, null), this);
    }
    if (this.props.model) {
        this.props.model.on("change", this.forceUpdate.bind(this, null), this);
    }
  },

  componentWillUnmount: function() {
    if (this.props.collection) {
        this.props.collection.off(null, null, this);
    }
    if (this.props.model) {
        this.props.model.off(null, null, this);
    }
  }
};

var BackboneBindingMixin = {
  bindTo: function(model, key){
    return {
       value: model.get(key),
       requestChange: function(value){
         model.set(key, value);
         var validateFunc = "validate_" + key;
         if (!_.isUndefined(model[validateFunc])) {
           model[validateFunc]();
         }
       }.bind(this)
    };
  }
};

module.exports = {
  BackboneChangeMixin: BackboneChangeMixin,
  BackboneBindingMixin: BackboneBindingMixin
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/react/mixins.js
 **/